export default __webpack_public_path__ + "assets/models/acd5bc4b57619203ddbb33bfa5bacd6a.glb";